import {
  Component,
  ElementRef,
  HostListener,
  OnInit,
  ViewChild,
} from '@angular/core';
import { LoginService } from '../../services/login.service';
import { SaasSelectionService } from '../../services/saas-selection.service';

@Component({
  selector: 'sol-sidebar',
  templateUrl: 'side-bar.component.html',
  styleUrls: ['./side-bar.component.scss'],
  standalone: false,
})
export class SideBarComponent implements OnInit {
  @HostListener('click', ['$event.target'])
  onClick(e: HTMLElement) {
    if (e.classList.contains('item-holder')) this.hideMenu();
  }
  @ViewChild('menu') menu!: ElementRef;

  constructor(
    private loginService: LoginService,
    private saasSelectionService: SaasSelectionService
  ) {}

  ngOnInit() {
    // SolloHQ #8: sol-sidebar mounts exactly once per login (isLogged
    // toggles it in app.component.html) and persists across route changes,
    // which is exactly the "once per login session, not per route change"
    // hook the SaaS card-selection modal needs.
    this.saasSelectionService.checkAndPromptIfPending();
  }

  showMenu() {
    this.menu.nativeElement.classList.add('show');
  }

  hideMenu() {
    this.menu.nativeElement.classList.remove('show');
  }

  onSignOut() {
    this.loginService.signout();
  }
}
